/**
 * The axis builders three pages share, so "Entity" means the same control and the same
 * disabled rule wherever it appears. A page picks the axes it has; it does not re-describe
 * them (Overview and Analytics carry all three, Margin has no grain, Capacity has neither
 * grain nor period and declares its own horizon and lens instead).
 */

import React from 'react'
import DateRangeSelector from '../DateRangeSelector'
import type { ScopeAxis } from './ScopeBar'
import { SITES, type Scope } from '../../hooks/useScope'
import type { Cadence, Site } from '../../types/metrics'

/** Group is disabled on weekly: the weekly master serves no Group rows (§4). */
export function entityAxis(scope: Scope): ScopeAxis {
  return {
    label: 'Entity',
    value: scope.site,
    onChange: (value) => scope.setSite(value as Site),
    options: SITES.map((site) => ({
      value: site,
      label: site,
      disabled: !scope.siteEnabled(site),
      title: scope.siteEnabled(site) ? undefined : 'The weekly master serves no Group rows',
    })),
  }
}

export function grainAxis(scope: Scope): ScopeAxis {
  return {
    label: 'Grain',
    value: scope.cadence,
    onChange: (value) => scope.setCadence(value as Cadence),
    options: [
      { value: 'monthly', label: 'Monthly' },
      { value: 'weekly', label: 'Weekly' },
    ],
  }
}

export function periodAxis(): ScopeAxis {
  return { label: 'Period', node: <DateRangeSelector /> }
}
